var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeCrossed = function SvgEyeCrossed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.36717C5.51268 5.36717 1.875 7.67133 1.875 10.5145C1.875 12.1397 3.06473 13.5898 4.92187 14.5325M10 5.36717L10 1.25M10 5.36717C11.0838 5.36365 12.1633 5.50409 13.2105 5.78483M2.89062 3.30917L4.56089 6.6925M4.92188 18.75L7.91071 15.4892M7.91071 15.4892L10.6964 12.45L11.9558 11.0722L15.7804 6.89783M7.91071 15.4892C8.60121 15.6046 9.30002 15.6623 10 15.6618C14.4873 15.6618 18.125 13.3577 18.125 10.5145C18.0165 8.98311 17.1303 7.6161 15.7804 6.89783M18.125 4.33817L15.7804 6.89783M8.35179 11.7243C7.90294 11.0987 7.83892 10.2736 8.18583 9.58551C8.53274 8.89747 9.2326 8.46147 10 8.45533C10.3781 8.45486 10.7486 8.56162 11.069 8.76333",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgEyeCrossed;